// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers';
import { CommentGroup } from './comment-group.js';
import { FlowEdge } from './flow-edge.js';
import { FlowNode } from './flow-node.js';
import { Meta } from './meta.js';
import { Variable } from './variable.js';
export class Flow {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsFlow(bb, obj) {
        return (obj || new Flow()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsFlow(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Flow()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static bufferHasIdentifier(bb) {
        return bb.__has_identifier('FSFL');
    }
    version(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    meta(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new Meta()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    nodes(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new FlowNode()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    nodesLength() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    edges(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? (obj || new FlowEdge()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    edgesLength() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    variables(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? (obj || new Variable()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    variablesLength() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    comments(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? (obj || new CommentGroup()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    commentsLength() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startFlow(builder) {
        builder.startObject(6);
    }
    static addVersion(builder, versionOffset) {
        builder.addFieldOffset(0, versionOffset, 0);
    }
    static addMeta(builder, metaOffset) {
        builder.addFieldOffset(1, metaOffset, 0);
    }
    static addNodes(builder, nodesOffset) {
        builder.addFieldOffset(2, nodesOffset, 0);
    }
    static createNodesVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startNodesVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addEdges(builder, edgesOffset) {
        builder.addFieldOffset(3, edgesOffset, 0);
    }
    static createEdgesVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startEdgesVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addVariables(builder, variablesOffset) {
        builder.addFieldOffset(4, variablesOffset, 0);
    }
    static createVariablesVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startVariablesVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addComments(builder, commentsOffset) {
        builder.addFieldOffset(5, commentsOffset, 0);
    }
    static createCommentsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startCommentsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endFlow(builder) {
        const offset = builder.endObject();
        builder.requiredField(offset, 4); // version
        return offset;
    }
    static finishFlowBuffer(builder, offset) {
        builder.finish(offset, 'FSFL');
    }
    static finishSizePrefixedFlowBuffer(builder, offset) {
        builder.finish(offset, 'FSFL', true);
    }
}
//# sourceMappingURL=flow.js.map